<template>
    <div class="mt-2">
        <iframe :src="route('trading-view-chart')"
                :name="tradingViewPair"
                rel="noindex nofollow"
                scrolling="no" />
    </div>
</template>

<script>
    import { route } from '../helpers/helpers';

    export default {
        name: 'TradingView',
        props: {
            tradingViewPair: {
                type: String,
                required: true,
            },
        },
        methods: { route },
    };
</script>

<style scoped lang="scss">
iframe {
    width: 100%;
    height: 502px;
    border: none;
}
</style>
